import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceTagForm from '../containers/ResourceTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceTagEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceTagEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resource_tag_route_edit')} />
          <ResourceTagForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceTagEditScreen;

Logger.log('silly', `ResourceTagEditScreen loaded.`);
